import { useMutation } from '@tanstack/react-query'

import { TANSTACK_QUERY_KEY } from '@/constants/tanstack-query'
import { queryClient } from '@/context'
import { IHttpError } from '@/data/core'
import { ILinkWalletPayload, ITrackWalletConnectedPayload, LinkWallet } from '@/data/wallet/models'

// link btc wallet to each other
export function useLinkWallet() {
  return useMutation<void, IHttpError, ILinkWalletPayload>({
    mutationKey: [TANSTACK_QUERY_KEY.WALLET.LINK_BTC_WALLET],
    mutationFn: async (payload) => {
      await LinkWallet.linkWallet(payload)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TANSTACK_QUERY_KEY.REFERRAL.ACCOUNT_COMMISSION_SUMMARY] })
      queryClient.invalidateQueries({ queryKey: [TANSTACK_QUERY_KEY.REFERRAL.REFERRAL_STATISTICS] })
    },
  })
}

export function useTrackWalletConnected() {
  return useMutation<void, IHttpError, ITrackWalletConnectedPayload>({
    mutationKey: [TANSTACK_QUERY_KEY.WALLET.TRACK_WALLET_CONNECTED],
    mutationFn: async (payload) => {
      await LinkWallet.trackWalletConnected(payload)
    },
  })
}
